import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CardTitleAndSubtitleContainer,
  WeeklyActivityTitleContainer,
} from '../../components/DashboardCards/cardStyles';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import { CommonGrid, PageTitle } from '../../styledComponents/common';
import { DashboardCardTitle } from '../../styledComponents/dashboard';
import CampReadinessNew from './CampReadiness/CampReadinessContainer';
import CheckedInCard from './components/CheckedInCard';
import SubtaskCard from './components/SubtaskCard';
import TopCards from './components/TopCards';
import {
  DashboardCardContainer,
  DashboardCardsContainer,
  DashboardPageContent,
  DashboardPageHeader,
  TitleAndModeSelectorDiv,
} from './dashboardStyles';

const DashboardNew = props => {
  const { t } = useTranslation();

  const {
    location,
    history,
    getDashboardStatus,
    getDashboardTaskProgress,
    getDashboardPerformance,
    getDashboardLateCount,
    getDashboardTopLowPerformers,
    getDashboardUserAnalytics,
    // dashboardData,
    employeeStatusIsloading,
    employee_status,
    getDashboardTaskSummary,

    // office status
    officeStatusIsLoading,
    officeStatusData,
    getDasboardOfficeStatus,

    // subtask status
    subtaskStatusIsLoading,
    subtaskStatusData,
    getDashboardSubtaskStatus,
  } = props;

  const userRole = localStorage.getItem('user_role');
  useEffect(() => {
    if (userRole === 'admin' || userRole === 'gm' || userRole === 'agm') {
      const payload = {
        date: moment(),
      };
      getDashboardStatus();
      // getDashboardLateCount();
      // getDashboardTopLowPerformers();
      getDashboardPerformance();
    }
    // getDashboardTaskProgress();
    getDashboardTaskSummary();
    getDasboardOfficeStatus();
    getDashboardSubtaskStatus();
  }, []);

  return (
    <div className="content">
      <DashboardPageHeader>
        <TitleAndModeSelectorDiv>
          <PageTitle marginBottom="0">{t('Dashboard')}</PageTitle>
        </TitleAndModeSelectorDiv>
      </DashboardPageHeader>
      <DashboardPageContent marginTop="20px">
        <DashboardCardsContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
          background="white"
          padding="20px"
          columnGap="0px"
        >
          <WeeklyActivityTitleContainer margin="0 0 10px 0" padding="0">
            <DashboardCardTitle>{t('overall_information')}</DashboardCardTitle>
          </WeeklyActivityTitleContainer>
          <DashboardCardContainer
            columns="1fr 1fr 1fr"
            tabletColumns="1fr 1fr"
            mobileColumns="1fr"
          >
            {employeeStatusIsloading && (
              <>
                <ComponentCircleLoader padding="0" />
                <ComponentCircleLoader padding="0" />
                <ComponentCircleLoader padding="0" />
              </>
            )}

            {employee_status &&
              userRole !== 'supervisor' &&
              userRole !== 'employee' && (
                <>
                  <TopCards
                    number={
                      employee_status?.online_employees +
                      employee_status?.offline_employees
                    }
                    border="#c9a98a"
                    color="#6b4a36"
                    label={t('total_employees')}
                  />
                  <TopCards
                    number={employee_status?.online_employees}
                    border="#9dcfb9"
                    color="#3d8b68"
                    label={t('working_today')}
                  />
                  <TopCards
                    number={employee_status?.offline_employees}
                    border="#ebb09a"
                    color="#c06040"
                    label={t('not_working_today')}
                  />
                </>
              )}
          </DashboardCardContainer>

          <CommonGrid columns="1fr 1fr">
            <CheckedInCard
              statusData={officeStatusData}
              loading={officeStatusIsLoading}
            />
            <SubtaskCard
              statusData={subtaskStatusData}
              loading={subtaskStatusIsLoading}
            />
          </CommonGrid>
        </DashboardCardsContainer>

        {/* Camp Readiness Dashboard */}
        {employee_status &&
          userRole !== 'supervisor' &&
          userRole !== 'employee' && (
            <DashboardCardsContainer
              columns="1fr"
              laptopColumns="1fr"
              tabletColumns="1fr"
              marginTop="20px"
              background="white"
              padding="20px"
              columnGap="0px"
            >
              <WeeklyActivityTitleContainer margin="0" padding="0">
                <DashboardCardTitle>
                  {t('camp_readiness_dashboard')}
                </DashboardCardTitle>
              </WeeklyActivityTitleContainer>

              <CampReadinessNew />
            </DashboardCardsContainer>
          )}
      </DashboardPageContent>
    </div>
  );
};

export default DashboardNew;
